import React from "react";
import { HomeComponent } from "../../components/home/homecomponent";


const Home = () => {

    return(
        <>
            <HomeComponent/>
        </>
    )
}

export default Home;